import { getOSSToken,getOSSTokenCharge  } from '@/api/setting'

export async function uploadFile(data, isCharge) {
  let resData = {};
  let aliyunOssToken = {};
  let signMethod = isCharge ? getOSSTokenCharge : getOSSToken
  await signMethod().then(function(res) {
          if (res.code == 200) {
            aliyunOssToken = res.data
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(function(error) {
          console.log(error)
        })
        
        const getSuffix = function(fileName) {
          const pos = fileName.lastIndexOf('.')
          let suffix = '.png'
          if (pos != -1) {
            suffix = fileName.substring(pos)
          }
          return suffix
        }
        const filename = new Date().getTime() + (data.name ? getSuffix(data.name) : '.png')
        let formData = new FormData()
        //注意formData里append添加的键的大小写
        formData.append('key', aliyunOssToken.dir + filename) //存储在oss的文件路径
        formData.append('OSSAccessKeyId', aliyunOssToken.accessid) //accessKeyId
        formData.append('policy', aliyunOssToken.policy) //policy
        formData.append('Signature', aliyunOssToken.signature) //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

        formData.append('file', data.raw ? data.raw : data)
        formData.append('success_action_status', 200) //成功后返回的操作码

        const url = aliyunOssToken.host
        const fileUrl =
          aliyunOssToken.host +
          '/' +
          aliyunOssToken.dir +
          filename
  await new Promise((resolve,reject)=>{
    $.ajax({
      url: url,
      type: 'POST',
      data: formData,
      // async: false,
      cache: false,
      contentType: false,
      processData: false,
      success: function(res) {
        // imageGroup.push({
        //   imageUrl: fileUrl,
        //   isMain: imageGroup.length === 0 ? true : false,
        // })
        resData.uploadFlag = true
        resData.fileUrl = fileUrl
        resolve(1)
      },
      error: function(data) {},
    }) 
  })
  return resData;
}